import { FC, useCallback } from 'react'
import { NavigationLink } from 'components/atoms/navigation/NavigationLink'
import Button from 'components/features/pfm/Button/Button'
import { useThemeClassNames } from 'hooks/useClassNames'
import { useStoreDispatch, useStoreSelector } from 'helpers/reactReduxHelpers'
import { PatchCCOnboardingPropsAction } from 'components/features/creditCard/creditCardStore/actions'
import Flex from 'components/atoms/Flex/Flex'


export const CheckingEligibilityContent: FC = () => {
  const onboarding = useStoreSelector((state) => state.data.creditCard.onboarding)
  const isOfferReceived = onboarding?.state === 'offer_received'
  const statusClasses = useThemeClassNames(isOfferReceived ? 'green' : 'orange', 'textOnly')

  const dispatch = useStoreDispatch()
  const reconsiderOffer = useCallback(() => {
    dispatch(new PatchCCOnboardingPropsAction({
      step: 'offer',
    }))
  }, [dispatch])

  return isOfferReceived ? (
    <Flex gap='spread'>
      <Flex marginBottom='defaultSize'>
        <h2>
          Your application is <strong className={ statusClasses } style={{ whiteSpace: 'nowrap' }}>Pre-Approved</strong>
        </h2>
        <p>
          Congratulations! You're one step away from getting your Status Card.
          <br /><br />
          Accept your offer to start shopping with your card today.
        </p>
      </Flex>
      <Button
        text='See Your Card Offer'
        onClick={ reconsiderOffer }
        qaMarker='see-offer-button'
      />
    </Flex>
  ) : (
    <Flex gap='spread'>
      <Flex marginBottom='defaultSize'>
        <h2>Your application is <strong className={ statusClasses }>pending</strong></h2>
        <p>
          We're reviewing a few additional pieces of information. <br />
          We'll reach out to you within 1-2 business days.
        </p>
      </Flex>
      <NavigationLink to='dashboard'>
        <Button text='See Your Money' />
      </NavigationLink>
    </Flex>
  )
}
